import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src1852518591/src/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/codebuild/output/src1852518591/src/layouts/empty.vue").then(m => m.default || m))
}